///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { AppConfigService } from "../app/core/app-config.service";

export const environmentBase = {
    appId: "098c5a82-a60a-45c2-b047-d62d297fd00d",
    appName: "SupplierPortal",
    getDataProviders() {
        return AppConfigService.settings.dataProviders;
    },
    getAuthentication() {
        return AppConfigService.settings.authentication;
    }
};



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/environments/environment-base.ts